import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";

const API_BASE_URL =
  process.env.NODE_ENV === "production" ? "" : "http://localhost:5001";

const REFERENCE_CHIPS = [
  { id: "mcp-gateway", label: "MCP" },
  { id: "eci", label: "ECI" },
  { id: "dqr-lab", label: "Lab" },
  { id: "pqc", label: "PQC" },
];

const THINKING_DELAY_MS = 3200;

function wait(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

async function invokeAgent(payload) {
  const response = await fetch(`${API_BASE_URL}/invoke-agent`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.answer || data.error || `HTTP ${response.status}`);
  }
  return data;
}

function Red4MinimalApp() {
  const [query, setQuery] = useState("");
  const [activeChip, setActiveChip] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const ask = async (payload) => {
    const started = Date.now();
    setBusy(true);
    setError("");
    setResult(null);
    try {
      const data = await invokeAgent(payload);
      const remainingDelay = THINKING_DELAY_MS - (Date.now() - started);
      if (remainingDelay > 0) {
        await wait(remainingDelay);
      }
      setResult(data);
    } catch (err) {
      const remainingDelay = THINKING_DELAY_MS - (Date.now() - started);
      if (remainingDelay > 0) {
        await wait(remainingDelay);
      }
      setError(err.message || "Red4 is unavailable.");
    } finally {
      setBusy(false);
    }
  };

  const runChip = (chip) => {
    setActiveChip(chip.id);
    setQuery("");
    ask({ route: chip.id });
  };

  const submit = (event) => {
    event.preventDefault();
    const clean = query.trim();
    if (!clean) return;
    setActiveChip("");
    ask({ query: clean });
  };

  useEffect(() => {
    document.title = "Red4";
  }, []);

  return (
    <main className="minimal-page">
      <section className="minimal-shell">
        <img src="/Red4 Dev Assist.jpg" alt="Red4" className="minimal-logo" />

        <form className="ask-box" onSubmit={submit}>
          <textarea
            value={query}
            onChange={(event) => setQuery(event.target.value)}
            placeholder="Ask a question about Red4..."
            rows={3}
          />
          <button disabled={busy || !query.trim()} type="submit">
            {busy ? "Thinking" : "Ask"}
          </button>
        </form>

        <div className="chip-row" aria-label="Red4 reference topics">
          {REFERENCE_CHIPS.map((chip) => (
            <button
              key={chip.id}
              className={activeChip === chip.id ? "active" : ""}
              disabled={busy}
              onClick={() => runChip(chip)}
            >
              {chip.label}
            </button>
          ))}
        </div>

        {(busy || error || result?.answer) && (
          <section className="minimal-answer">
            {busy && <div className="minimal-loading">Thinking</div>}
            {!busy && error && <div className="minimal-error">{error}</div>}
            {!busy && !error && result?.answer && (
              <ReactMarkdown>{result.answer}</ReactMarkdown>
            )}
          </section>
        )}

        <footer className="minimal-credit">Powered by the Red4 MCP Gateway</footer>
      </section>
    </main>
  );
}

export default Red4MinimalApp;
